

















import { Component, Vue, Watch } from "vue-property-decorator";
import { RouteRecord } from "vue-router";
import * as pathToRegexp from "path-to-regexp";

@Component
export default class Breadcrumb extends Vue {
  private breadcrumbs: RouteRecord[] = [];

  private created() {
    this.getBreadcrumb();
  }

  @Watch("$route")
  private onRouteChange() {
    this.getBreadcrumb();
  }

  private getBreadcrumb() {
    let matched = this.$route.matched.filter(item => item.name);
    const first = matched[0];
    if (first && first.name !== "dashboard") {
      matched = [
        { path: "/", meta: { title: "Dashboard" } } as RouteRecord
      ].concat(matched);
    }
    this.breadcrumbs = matched.filter(item => {
      return item.meta && item.meta.title && item.meta.breadcrumb !== false;
    });
  }

  private pathCompile(path: string) {
    // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
    const { params } = this.$route;
    const toPath = pathToRegexp.compile(path);
    return toPath(params);
  }

  private handleLink(item: any) {
    const { redirect, path } = item;
    if (redirect) {
      this.$router.push(redirect);
      return;
    }
    this.$router.push(this.pathCompile(path));
  }
}
